module.exports = "<p>\n  404: Page Not found\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagenotfound/pagenotfound.component.html
// module id = 447
// module chunks = 0